
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
	name: 'ChipButtons',
})
export default class ChipButtons extends Vue {}
